/**
 * Hastanın ödeme sayfasının genel yolu: `${origin}${PUBLIC_PAY_PATH}/${belirteç}`.
 *
 * **Tek kaynak (H20).** Sabit `@dentos/contracts`'ta yaşar çünkü onu okuyan iki taraf var ve
 * aralarındaki TEK köprü bu paket: sunucu tarafında Payment adaptörü, rotalar ve testler;
 * web tarafında hastanın gördüğü sayfanın rota tanımı. `apps/web` `apps/api`'den import
 * edemez — sabit `apps/api` içinde kalsaydı `/odeme` dizesi web'de İKİNCİ kez elle yazılırdı
 * ve hükmün kilitlemek istediği yer tam da orası olurdu.
 *
 * **Neden kendi modülü (H60, ölçüldü).** Sabit `payments.ts`'te dururken web'in rota tablosu
 * onu okumak için o modülü — ve onun üzerinden `common.ts`'in zod şemalarını — giriş grafiğine
 * sokuyordu: ilk boyamada çekilen JS 80,00 kB idi ve 23,30 kB'ı yalnızca bu yüzden gelen
 * `chunk-common`dı. `sideEffects: false` ve `/*#__PURE__*\/` notu açığı kapatmadı. Sabit
 * zod'a DOKUNMAYAN bu modülde durduğu için grafik artık şemaları çekmiyor.
 *
 * Bu dosyaya zod (ya da zod'a dokunan herhangi bir modül) import ETME — kazanç anında geri gider.
 */
export const PUBLIC_PAY_PATH = '/odeme';
//# sourceMappingURL=payments-path.js.map